export default class CommentModel {
    text : string = ''
    img : string = ''
    index !: number
    searchAreaIndex !: number

    setImg (img: any) {
      this.img = img
    }

    setText (txt: string) {
      this.text = txt
    }

    reset () {
      this.img = ''
      this.text = ''
    }
}
